import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';

export const exportGrid = (e, fileName) => {
    const exportFileName = `${fileName}_${new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }).replace(/\//g, '-')}`;
    if (e.format === 'xlsx') {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        const exportDataGridHandler = () => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${exportFileName}.xlsx`);
            });
        };

        exportDataGrid({
            worksheet: worksheet,
            component: e.component,
        }).then(exportDataGridHandler);
    }
};

export const exportFormats = ['xlsx'];
